/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { analytics } from 'services/Analytics'
import { withLocalization } from 'hocs/localization'
import { getGeneralContact } from 'redux-app/selectors/contacts'
import ContactUs from './ContactUs'

export default compose(
  connect(
    state => ({
      generalContact: getGeneralContact(state),
    }),
    null,
  ),
  withLocalization('contactUs'),
  lifecycle({
    componentDidMount () {
      analytics.openContactPage()
    },
  }),
)(ContactUs)
